import { useEffect, useCallback, useReducer, useRef } from "react";
import useDidMountEffect from "./useDidMountEffect";

const initialState = {
  status: "idle",
  isLoading: false,
  value: null,
  error: null
};

const asyncReducer = (state, action) => {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        status: "loading",
        isLoading: true,
        // value: null,
        // error: null
      };
    case "success":
      return {
        ...state,
        status: "success",
        isLoading: false,
        value: action.payload,
        error: null
      };
    case "error":
      return {
        ...state,
        status: "error",
        isLoading: false,
        value: null,
        error: action.payload
      };
    default:
      return state;
  }
};

export const useAsync = (
  asyncFunction,
  { defaultMounted = false, immediate = true, defaultValue = null } = {}
) => {
  const [state, dispatch] = useReducer(asyncReducer, {...initialState,  value: defaultValue });
  const mounted = useRef(defaultMounted);

  const execute = useCallback((...args) => {
    dispatch({ type: "loading" });
    return asyncFunction(...args)
      .then((response) => {
        if (mounted.current) {
          dispatch({ type: "success", payload: response });
        }

        return response;
      })
      .catch((error) => {
        if (mounted.current) {
          dispatch({ type: "error", payload: error });
        }

        return error;
      });
  }, [asyncFunction]);

  useEffect(() => {
    if (immediate) {
      execute();
    }
  }, [execute, immediate]);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return {
    execute,
    status: state.status,
    value: state.value,
    error: state.error,
    isLoading: state.isLoading
  };
};
